<div
	class="flex w-11 h-11 rounded-full justify-center items-center bg-blue-300 hover:bg-blue-100 cursor-pointer"
	(click)="selected()"
	*ngIf="!selectedUserId"
>
	<app-icon [icon]="ICON.ADD"></app-icon>
</div>

<app-business-user
	[disabled]="disabled"
	[showName]="false"
	[userId]="selectedUserId"
	*ngIf="selectedUserId"
	class="flex cursor-pointer"
	(click)="selected()"
	size="small"
></app-business-user>
